﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import { createUseStyles } from "react-jss";
import type { SoPNLConsilioTheme } from "~jrad/Styling/SoPNLConsilioTheme";

//-------------------------------------------------------------------------------------
// Styling
//-------------------------------------------------------------------------------------

export const useStyles = createUseStyles((theme: SoPNLConsilioTheme) => ({
    page: {
        width: "800px",
        textAlign: "left",
        margin: "0 auto",
        padding: "0 50px",
    },
    hiddenPageWidthSizer: {
        visibility: "hidden",
        height: 0,
        overflow: "hidden",
    },
    pageMenu: {
        marginTop: "30px",
    },
    pageContainer: {},
    pageHeader: {
        textAlign: "center",
        fontSize: "40px !important",
        marginBottom: "20px !important",
    },
    pageIntroDescription: {
        textAlign: "center",
        fontSize: "20px",
        lineHeight: "1.4",
    },
    resumeExistingSession: {
        border: `2px solid ${theme.constants.primaryColor}`,
        borderRadius: "4px",
        padding: "10px 14px",

        margin: "20px 0",
    },
    resumeExistingSessionContainer: {},
    resumeExistingSessionHeader: {
        fontFamily: theme.constants.defaultFont,
        fontSize: "20px",
        marginBottom: "8px",
    },
    resumeExistingSessionDescription: {
        fontFamily: theme.constants.defaultFont,
        fontSize: "15px",
        marginBottom: "10px",
    },
    resumeExistingSessionButton: {
        height: "fit-content",
        width: "fit-content",
        marginLeft: "auto",
        marginRight: 0,
    },
    sessionModelsHeader: {
        fontFamily: theme.constants.headerFont,
        fontSize: "25px",
        margin: "20px 0",
    },
    sessionModelsGrid: {
        display: "grid",
        gridTemplateColumns: "1fr",
        gridAutoRows: "1fr",
        gap: "20px",
        marginTop: "20px",
        marginBottom: "40px",
    },
    sessionModelContainer: {
        position: "relative",
        border: "1px solid #c6c5c5",
        borderTop: `4px solid ${theme.constants.secondaryBorderColor}`,
        borderRadius: "4px",
        padding: "10px 15px",

        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        gap: "20px",
    },
    sessionModelContentContainer: {
        flex: "1 0",
    },
    sessionModelIcon: {
        display: "none",
        alignSelf: "center",
        height: "64px",
        width: "64px",
    },
    sessionModelHeader: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        fontFamily: theme.constants.defaultFont,
        fontSize: "18px",
        fontWeight: 500,
        marginBottom: "7px",
    },
    sessionHeaderDate: {},
    sessionHeaderStatus: {
        fontWeight: 400,
        textTransform: "uppercase",
        fontSize: "0.85em",
    },
    sessionModelDescription: {
        fontFamily: theme.constants.defaultFont,
        fontSize: "16px",
        lineHeight: 1.1,
    },
    sessionModelButton: {
        height: "fit-content",
        width: "fit-content",
        alignSelf: "end",
    },
    sessionModelBlockedOverlay: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        top: "-4px",
        right: "-1px",
        bottom: "-1px",
        left: "-1px",
        borderRadius: "4px",
        background: "rgba(255, 255, 255, 0.8)",
    },
    sessionModelBlockedOverlayContent: {
        color: theme.constants.invalidColor,
        fontFamily: theme.constants.defaultFont,
        fontSize: "16px",
        fontWeight: 500,
        maxWidth: "90%",
        marginTop: "4px",
        padding: "4px 8px",
        borderRadius: "4px",
        textShadow: "#ffffff 0 0 5px",
    },
    hiddenSearchButton: {
        display: "none",
    },
}));
